import { configService } from '@/services/config/config.service';
import { BalancerSDK, Network } from 'balancer-labs-sdk-fuji';
import config from '@/lib/config';

const network = ((): Network => {
  switch (configService.network.key) {
    case '1':
      return Network.MAINNET;
    case '42':
      return Network.KOVAN;
    case '137':
      return Network.POLYGON;
    case '42161':
      return Network.ARBITRUM;
    case '43113':
      return Network.FUJI;
    default:
      return Network.MAINNET;
  }
})();

console.log('rpc', configService.rpc);

export const balancer = new BalancerSDK({
  network: {
    chainId: network,
    addresses: {
      contracts: {
        vault: config[network].addresses.vault,
        multicall: config[network].addresses.multicall
      },
      tokens: {
        wrappedNativeAsset: config[network].addresses.weth
      }
    },
    urls: {
      subgraph: config[network].subgraph
    },
    pools: {
      wETHwstETH: {
        id:
          '0x28caa1230b6fa7e113b5180d8b0b80c9619b1c36000200000000000000000837',
        address: '0x28caa1230b6fa7e113b5180d8b0b80c9619b1c36'
      }
    }
  },
  rpcUrl: configService.rpc
});
